import { capitalize } from '@repo-level/core-front';
import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import type { InputStructureProps } from '../structures/InputStructure';
import { InputStructure } from '../structures/InputStructure';
import type { ScInputProps } from './styled';
import { ScInput, ScInputIcon, ScInputInternalLabel } from './styled';

export type InputBlockProps = InputHTMLAttributes<HTMLInputElement> &
  InputStructureProps & {
    icon?: string;
    internalLabel?: string;
  } & Omit<ScInputProps, 'error' | 'icon'>;

export const InputBlock = forwardRef<HTMLInputElement, InputBlockProps>(
  (
    {
      error,
      hideErrorMessage,
      prefix,
      disabled,
      icon,
      whiteWhenFilled,
      internalLabel,
      ...rest
    },
    ref
  ) => (
    <InputStructure
      disabled={disabled}
      error={error}
      hideErrorMessage={hideErrorMessage}
      whiteWhenFilled={whiteWhenFilled && !!rest.value}
      {...rest}
    >
      {icon && <ScInputIcon alt="" src={icon} />}
      {internalLabel && (
        <ScInputInternalLabel>{internalLabel}</ScInputInternalLabel>
      )}
      <ScInput
        {...rest}
        className={rest.value != null && rest.value !== '' ? 'filled' : ''}
        disabled={disabled}
        error={error != null}
        icon={icon != null}
        placeholder={rest.placeholder && capitalize(rest.placeholder)}
        ref={ref}
        whiteWhenFilled={whiteWhenFilled && !!rest.value}
      />
    </InputStructure>
  )
);
